export class ImageGenerationRequest {
    public model: string | null = null
    public prompt: string | null = null
    public response_format: string | null = null
    public n: number = 1
}
